import {Group} from "./../groups/group.model";

export class User {
    public id : number;
    public firstname : string;
    public lastname : string;
    public username : string;
    public password : string;
    public confirmPassword : string;
    public lastaccess : string;
    public active : boolean;
    public version : number;
    public validTo : string;
    public groups: Group[];
    
     constructor() {
        this.groups = [];    
     }
}
